<template>
  <div class="p-timeline">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="p-timeline__item"
      :class="{ 'p-timeline__item--last': index === items.length - 1 }"
    >
      <div class="p-timeline__icon">
        <p-icon icon="check" color="fg-fix-white" size="xs" />
      </div>
      <div class="p-timeline__content">
        <div class="p-timeline__date f-utility-14-medium t-fg-secondary">
          {{ item.date }}
        </div>
        <div class="p-timeline__description f-utility-14 t-fg-primary">
          {{ item.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface TimelineItem {
  date: string
  description: string
  icon?: string
  iconColor?: string
}

interface Props {
  items: TimelineItem[]
}

withDefaults(defineProps<Props>(), {
  items: () => [],
})
</script>
